import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/rooms`;
const headers = () => ({ headers: { Authorization: "Bearer " + localStorage.getItem("token") } });

export const listRooms = () => axios.get(base, headers());
export const createRoom = body => axios.post(base, body, headers());
export const updateRoom = (id, body) => axios.put(`${base}/${id}`, body, headers());
export const deleteRoom = id => axios.delete(`${base}/${id}`, headers());

/** Bookings overlapping [from, to) (Date, dayjs or moment). */
export const listBookings = (from, to) =>
  axios.get(`${base}/bookings`, {
    ...headers(),
    params: {
      from: new Date(from.valueOf()).toISOString(),
      to: new Date(to.valueOf()).toISOString()
    }
  });
export const createBooking = body => axios.post(`${base}/bookings`, body, headers());
export const updateBooking = (id, body) => axios.put(`${base}/bookings/${id}`, body, headers());
export const deleteBooking = id => axios.delete(`${base}/bookings/${id}`, headers());
